import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import FormRow from 'modules/core/components/FormRow'
import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import type QuestionCategory from 'modules/reviews/store/models/QuestionCategory'

interface Props {
  section: QuestionCategory
  onClose: () => void
  onSubmit: (data: Record<string, unknown>) => Promise<unknown>
}

export function EditSectionModal({ section, onSubmit, onClose }: Props) {
  const [sectionName, setSectionName] = React.useState(section.attributes.name)

  const performAction = async (closePortal: ClosePortalFn) => {
    const payload = {
      name: sectionName,
      question_category_id: section.attributes.id,
    }
    const success = await onSubmit(payload)

    if (success) closePortal()
  }

  return (
    <Modal
      illustration={'add-block'}
      title={i18n.t('surveys.form.question_categories.edit.title')}
      description={i18n.t('surveys.form.question_categories.edit.description')}
      onClose={onClose}
      onSubmit={performAction}
      footer={
        <Button disabled={!sectionName} submit>
          {i18n.t('surveys.form.question_categories.edit.submit')}
        </Button>
      }
    >
      <FormRow>
        <TextField
          label={i18n.t('surveys.form.question_categories.edit.label')}
          value={sectionName}
          placeholder={i18n.t('surveys.form.question_categories.edit.label_placeholder')}
          mandatory
          onChange={(sectionName) => setSectionName(sectionName)}
        />
      </FormRow>
    </Modal>
  )
}
